import { useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { styled } from '@mui/material/styles'
import { Box, Popover, Step, StepLabel, Stepper, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { getLabel, psegStepsMapper, ctessStepsMapper, steps, stepsMapper } from './constant'
import { useStyles } from './style'
import { PROGRAM_KEY } from '../../constants/common'
import { APPLICATIONREJECTED, SITEREJECTED } from '../../layouts/ViewApplication/constant'

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 12px)',
    right: 'calc(50% + 12px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
      opacity: '100%'
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
      opacity: '100%'
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#707070',
    borderTopWidth: 3,
    borderRadius: 1,
    opacity: 0.17
  },
}))

// const Stepper = styled('div')(({ theme, ownerState }) => ({
//   '& .CustomStep-labels:hover': {
//     color: '#000000',
//     fontWeight: 'bold',
//     border: '5px solid black'
//   },
// }))

const CustomStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#784af4',
  }),
  '& .CustomStepIcon-errorIcon': {
    color: '#F32020',
    zIndex: 1,
    fontSize: 30,
  },
  '& .CustomStepIcon-completedIcon': {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 30,
  },
  '& .CustomStepIcon-errorIcon:hover': {
    fontSize: 35,
  },
  '& .CustomStepIcon-completedIcon:hover': {
    fontSize: 35,
  },
  '& .CustomStepIcon-activeIcon': {
    color: '#707070',
    opacity: 0.5,
  },
  '& .CustomStepIcon-circle': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 22,
    height: 22,
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    border: '2px solid #F47321',
    color: '#F47321',
    zIndex: 99,
    textAlign: 'center'
  },
  '& .CustomStepIcon-activeWrapper': {
    minHeight: '75px'
  },
}))

const CustomStepIcon = (props) => {
  const { active, completed, className, icon, error } = props
  return (
    <CustomStepIconRoot ownerState={{ active }} className={className}>
      {error ? (
        <Box display="flex" flexDirection="column" alignItems="center" className="CustomStepIcon-activeWrapper">
          <KeyboardArrowDownIcon className="CustomStepIcon-activeIcon" />
          <CancelIcon className="CustomStepIcon-errorIcon" />
        </Box>
      ) : completed ? (
        <CheckCircleIcon className="CustomStepIcon-completedIcon" />
      ) : active ? (
        <>
          <Box display="flex" flexDirection="column" alignItems="center" className="CustomStepIcon-activeWrapper">
            <KeyboardArrowDownIcon className="CustomStepIcon-activeIcon" />
            <div className="CustomStepIcon-circle">{icon}</div>
          </Box>
        </>
      ) : (
        <div className="CustomStepIcon-circle">{icon}</div>
      )}
    </CustomStepIconRoot>
  )
}

CustomStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
}

const CustomStepper = (props) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)
  const { program, formData } = props

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <Stepper alternativeLabel activeStep={_.get(props, 'currentStep', 0)} connector={<CustomConnector />} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
        {program && program.program_key !== PROGRAM_KEY.APS_RBP && formData ?
          formData.states.map((state, index) => {
            const labelProps = {}
            if (state.default_label === psegStepsMapper[props.status]) {
              labelProps.error = true
            } else if (state.default_label === ctessStepsMapper[props.status]) {
              labelProps.error = true
            }
            let labelToBeShown = state.default_label
            state.application_states.forEach(applicationState => {
              if (applicationState.application_status === props.status) {
                labelToBeShown = applicationState.label
              }
            })
            return (
              <Step key={state.default_label} sx={{ mt: 4 }}>
                <StepLabel {...labelProps} className={classes.customStepLabels} StepIconComponent={CustomStepIcon} onMouseEnter={(e) => { setCurrentStep(index); handlePopoverOpen(e) }} onMouseLeave={handlePopoverClose} StepIconProps={{ setCurrentStep: setCurrentStep, handlePopoverOpen: handlePopoverOpen, handlePopoverClose: handlePopoverClose }}>
                  <Box component="span" sx={{ opacity: 0.5, color: '#000000' }}>{labelToBeShown}</Box>
                </StepLabel>
              </Step>
            )
          })
          : ''}
        {program && program.program_key === PROGRAM_KEY.APS_RBP &&
          props.steps.map((label) => {
            const labelProps = {}
            if (label === stepsMapper[props.status]) {
              labelProps.error = true
            }
            return (
              <Step key={label} sx={{ mt: 4 }}>
                <StepLabel {...labelProps} className={classes.customStepLabels} StepIconComponent={CustomStepIcon} onMouseEnter={(e) => { setCurrentStep(props.steps.indexOf(label)); handlePopoverOpen(e) }} onMouseLeave={handlePopoverClose} StepIconProps={{ setCurrentStep: setCurrentStep, handlePopoverOpen: handlePopoverOpen, handlePopoverClose: handlePopoverClose }}>
                  <Box component="span" sx={{ opacity: 0.5, color: '#000000' }}>{getLabel(label, props.status)}</Box>
                </StepLabel>
              </Step>
            )
          })}
      </Stepper>
      <Popover
        classes={{ paper: classes.paper }}
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          marginTop: '10px'
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box className={classes.popoverContainer}>
          <Box display="flex" justifyContent="center">
            <img src={program && program.program_key !== PROGRAM_KEY.APS_RBP && formData ? formData.states && formData.states[currentStep].image : steps[currentStep].img} className={classes.popoverImg} alt="" />
          </Box>
          <Typography className={classes.popoverText}>{program && program.program_key !== PROGRAM_KEY.APS_RBP && formData ? formData.states && formData.states[currentStep].text : steps[currentStep].description}</Typography>
        </Box>
      </Popover>
    </>
  )
}

export default CustomStepper
